import React from "react";
import { Ticket, TicketComment } from "core/types/ticket";

const Comment = ({ comment: item, previousComment }: { comment: TicketComment | Ticket, previousComment?: TicketComment }) => {
  const ticket = item as Ticket;
  const comment = item as TicketComment;

  const isTicket = !comment?.body;

  const className = !isTicket && comment.incoming
    ? "received"
    : "sent";

  const message = isTicket ? ticket.description : comment.body;

  const showDate = isTicket || previousComment && previousComment.created_at !== item.created_at;

  let date = item.date;

  if (showDate) {
    const year = new Date(item.created_at).getFullYear();

    if (!date.includes(year.toString())) {
      date += ` ${year}`;
    }
  }

  return (
    <>
      {showDate ? <li className="date">{date}</li> : null}

      <li className={className}>
        <strong>{item.user_name}</strong>

        <div className="message" dangerouslySetInnerHTML={{ __html: message }} />

        <div className="message-footer">
          <ol className="attachments">
            {item.attachments?.length ? (
              <>
                {
                  item.attachments.map((attachment: any, index: number) => {
                    return (
                      <li>
                        <a key={index} href={attachment.attachment_url} target="_blank" rel="noreferrer">
                          {attachment.name}
                        </a>
                      </li>
                    );
                  })
                }
              </>
            ) : null}
          </ol>

          <em>
            <span className="date">{item.date}</span>&nbsp;<span className="time">{item.time}</span></em>
        </div>
      </li>
    </>
  );
};

export default Comment;
